var _defs, _path, _path2, _path3, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "insta",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.181,
    y1: -0.052,
    x2: 0.819,
    y2: 1.052,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#f2203e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#b729a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5342d6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M2.25,0h13.5A2.257,2.257,0,0,1,18,2.25v13.5A2.257,2.257,0,0,1,15.75,18H2.25A2.257,2.257,0,0,1,0,15.75V2.25A2.257,2.257,0,0,1,2.25,0Z",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M14.113,5H8.262A3.313,3.313,0,0,0,5,8.319v5.737a3.313,3.313,0,0,0,3.262,3.319h5.85a3.313,3.313,0,0,0,3.262-3.319V8.319A3.313,3.313,0,0,0,14.113,5Zm2.137,8.944A2.306,2.306,0,0,1,14,16.25H8.375a2.306,2.306,0,0,1-2.25-2.306V8.375a2.221,2.221,0,0,1,2.25-2.25H14a2.306,2.306,0,0,1,2.25,2.306Z",
    transform: "translate(-2.188 -2.188)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M13.461,10.4a3.179,3.179,0,1,0,3.094,3.263V13.6A3.077,3.077,0,0,0,13.461,10.4Zm0,5.175a2.053,2.053,0,1,1,2.025-2.081v.056A2.017,2.017,0,0,1,13.461,15.574Z",
    transform: "translate(-4.461 -4.549)",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 0.675,
    cy: 0.731,
    rx: 0.675,
    ry: 0.731,
    transform: "translate(11.587 4.894)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.acfdaec9bc40c55a7923a0287947446b.svg";
export { ForwardRef as ReactComponent };